import { Stack } from "@circle-react-shared/BuilderUI/DefaultBlocks/Content/StackBlock/StackBlock";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { omit } from "lodash";
import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";

export interface FormStackBlockProps extends ComponentPropsWithRef<"div"> {
  children: ReactNode;
  styles?: Readonly<Record<string, StyleValue>>;
}

export const FormStackBlock = forwardRef<HTMLDivElement, FormStackBlockProps>(
  ({ children, styles, ...rest }, ref) => {
    const elementProps = omit(rest, ["blockPath"]);
    return (
      <Stack ref={ref} styles={styles} {...elementProps}>
        {children}
      </Stack>
    );
  },
);

FormStackBlock.displayName = "FormStackBlock";
